import Pathes from '@/helpers/pathes';
import axios from '@/axios-api';
import { getQuery } from '@/helpers/utils';

export const historyService = {
  allRounds: () => axios.get(Pathes.RoundHistory.allRounds),
  roundsSummary: () => axios.get(Pathes.RoundHistory.pastRoundStats),
  countriesById: params =>
    axios.get(Pathes.RoundHistory.roundCountries + getQuery(params)),
  brandsBatchById: (fundraisingId, params) =>
    axios.get(Pathes.RoundHistory.batchByID(fundraisingId) + getQuery(params)),
  repaymentProgressById: fundraisingId =>
    axios.get(Pathes.RoundHistory.roundRepaymentProgress(fundraisingId)),
  loanGroupsById: fundraisingId =>
    axios.get(Pathes.RoundHistory.roundLoanGroupStatements(fundraisingId)),
};
